import useEffectWithOptions from "./useEffectWithOptions";
import UseEffectOptions from "./UseEffectOptions";

export default function useWillUnmountEffect(effect: () => void, options?: UseEffectOptions): void {
    return useEffectWithOptions(() => effect, [], options);
}
